export default __webpack_public_path__ + "static/media/m_foodieBooster02.d6226e2a.png";